import React, { useEffect, useState, useRef } from "react";
import backgroundfee from "../../assets/video/feebackground.mov";
import logoImg from "../../assets/images/Logo.png";
import doneImg from "../../assets/images/done.gif";
import "./components/style.css";
import { Dialog } from "@material-ui/core";
import { getStudentBalance } from "../../api/student";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router";
import { CircularProgress } from "@material-ui/core";
import { BASE_URL } from "../../util/constants";
import axios from "axios";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function PaymentFee() {
  const amount = (e) => {
    const format = new Intl.NumberFormat("en-US").format(e);
    if (format.indexOf(".") > 0) {
      return format.substr(0, format.indexOf("."));
    } else {
      return new Intl.NumberFormat("en-US").format(e);
    }
  };
  const env = useQuery().get("env");
  const { studentId } = useParams();
  let query = useQuery().get("string");
  const success = useQuery().get("success");

  const studentIdParam = studentId?.split("-")[0];

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [student, setStudent] = useState({});
  const [paid, setPaid] = useState(false);
  const [customAmount, setCustomAmount] = useState(null);
  const [defaultPay, setDefaultPay] = useState(true);

  const customInputRef = useRef(null);
  /////

  const [openDialog, setOpenDialog] = useState(false);

  const handleOpenDialog = (v) => {
    setOpenDialog(v);
  };
  const handleClose = () => {
    setOpenDialog(false);
  };
  const handleDownload = () => {
    setOpenDialog(false);
    setPaid(true);
  };

  const handleReturn = () => {
    setPaid(false);
  };
  const handleCustomAmount = (e) => {
    const { name, value } = e.target;
    if (name === "custom-amount") setCustomAmount(value);
  };

  const handleClickToPay = async () => {
    const orderSchoolId = student.schoolId;
    const orderAmount = defaultPay
      ? student.total_balance_amount
      : customAmount;
    const orderStudentId = studentIdParam;

    if (orderAmount <= 0)
      return setError("Order amount invalid. Please try again.");

    const apiRes = await (await fetch(`${BASE_URL}/admin/get-order-id`)).json();
    if (apiRes && apiRes.status && apiRes.orderId) {
      const orderId = apiRes.orderId;
      // const appEnv = window.location.hostname.includes("localhost")
      //   ? "local"
      //   : "live";
      let envString = '';
      if (env)
        envString = '&env=' + env;
      const redirectUrl = `https://discoveritech.com/schoolpay-transactions/school_pay_init_new.php?schoolId=${orderSchoolId}&amount=${orderAmount}&orderid=${orderId}&sId=${orderStudentId}-${orderAmount}&merchantID=${student.merchantId}${envString}`;

      setLoading(true);
      window.location.href = redirectUrl;
    } else setError("Unable to fetch orderId. Please try again.");
  };

  useEffect(() => {
    if (success) setOpenDialog(true);
    getStudentBalance(studentIdParam).then((data) => {
      if (data.status) {
        setStudent(data.student);
        const dueAmount = data.student.total_balance_amount;
        setCustomAmount(dueAmount > 0 ? dueAmount : "");

        if (query) {
          setLoading(true);
          const successAmount = studentId?.split("-")[1];
          // post the string to api backend for verification
          axios
            .post(`${BASE_URL}/transaction/process-fee-payment`, {
              bankResponse: query,
              amount: successAmount,
              schoolId: data.student.schoolId,
              studentId: studentIdParam,
            })
            .then((response) => {

              if (response.data.status === true) {
                window.location.href = studentIdParam + "?success=true";
              }
            })
            .catch((error) => {
              setError("Transaction verification failed");
              setLoading(false);
            });
        } else setLoading(false);
      } else {
        setError("Something went wrong. Please try  again.");

        setLoading(false);
      }
    });
  }, [studentId]);

  return (
    <div className="mainDiv">
      <div className="backgroundDiv">
        <video
          className="backgroundDivVideo"
          autoPlay
          muted
          loop
          src={backgroundfee}
        />
      </div>
      <div className="feeCardDiv">
        <div className="card-style feeCard">
          <div className="logoImgDiv">
            <img src={logoImg} />
          </div>

          {!!loading && (
            <CircularProgress size={20} className="pendingCircle" />
          )}

          {error && !loading && (
            <>
              <div className="fee-error">{error}</div>
              <div className="fee-pay-butdiv">
                <button
                  className="fee-pay-button"
                  onClick={() => window.location.reload()}
                >
                  Click to reload
                </button>
              </div>
            </>
          )}

          {!error && !loading && (
            <>
              <div className="fee-details">
                <div className="fee-details-row">
                  <div className="fee-details-rowleft fee-text">
                    School Name
                  </div>
                  <div className="fee-details-rowright fee-text">
                    {student.schoolName}
                  </div>
                </div>
                <div className="fee-details-row">
                  <div className="fee-details-rowleft fee-text">Student ID</div>
                  <div className="fee-details-rowright fee-text">
                    {studentIdParam}
                  </div>
                </div>
                <div className="fee-details-row">
                  <div className="fee-details-rowleft fee-text">
                    Student Name
                  </div>
                  <div className="fee-details-rowright fee-text">
                    {student.firstName} {student.lastName}{" "}
                  </div>
                </div>
                <div className="fee-details-row">
                  <div className="fee-details-rowleft fee-text">
                    Student Grade
                  </div>
                  <div className="fee-details-rowright fee-text">
                    {student.grade}
                  </div>
                </div>
                <div className="fee-details-row">
                  <div className="fee-details-rowleft fee-text">
                    Payment Date
                  </div>
                  <div className="fee-details-rowright fee-text">
                    {student.dueDate}
                  </div>
                </div>
                <div className="fee-details-row">
                  <div className="fee-details-rowleft fee-text">Amount Due</div>
                  <div className="fee-details-rowright fee-text">
                    AED {amount(student.total_balance_amount)}
                  </div>
                </div>
              </div>
              {!paid && (
                <>
                  <div className="fee-total-amountdiv">
                    <div className="fee-total-amount-opt">
                      <div
                        onClick={() => setDefaultPay(true)}
                        className={`fee-total-amount-first ${defaultPay ? "fee-total-amount-second-active" : ""
                          }`}
                      >
                        Pay Full Amount
                      </div>
                      <div className="fee-total-amount-second" />
                      <div
                        onClick={() => {
                          setDefaultPay(false);
                        }}
                        className={`fee-total-amount-third  ${!defaultPay ? "fee-total-amount-second-active" : ""
                          }`}
                      >
                        Enter Amount To Pay
                      </div>
                    </div>
                    <div className="fee-total-amount">
                      {defaultPay ? (
                        <>
                          <div className="fee-total-amount-head">
                            Total Amount
                          </div>
                          <div className="fee-total-amount-value">
                            AED {amount(student.total_balance_amount)}
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="fee-total-amount-head">
                            Enter Amount
                          </div>
                          <div className="fee-total-amount-value">
                            <div className="fee-tota-input-div">
                              <div>AED</div>{" "}
                              <input
                                ref={customInputRef}
                                id="custom-amount"
                                name="custom-amount"
                                value={customAmount ?? ""}
                                onChange={(e) => handleCustomAmount(e)}
                                className="fee-tota-input"
                              />
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="fee-pay-butdiv">
                    <button
                      className="fee-pay-button"
                      onClick={handleClickToPay}
                    >
                      Click to pay
                    </button>
                  </div>
                </>
              )}
              {paid && (
                <>
                  <div className="mainBtnBAckiv">
                    <div onClick={handleReturn}>Back</div>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>
      <Dialog
        classes={{ root: "feeDialog", container: "marginAuto" }}
        onClose={handleClose}
        aria-labelledby="simple-dialog-title"
        open={openDialog}
      // maxWidth={"xs"}
      >
        <div className="paydialogdiv">
          <div className="paydialogdone">
            <img src={doneImg} />
          </div>
          <div className="congratesHead">Congratulation</div>
          <div className="congratesSubText">
            You have Succesfully transfered the amount
          </div>
          <div className="downloadBtnSumDiv">
            <button onClick={handleDownload}>Download Print Summary</button>
          </div>
          <div className="downloadBtnBAckiv">
            <div onClick={handleClose}>Back</div>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
